<div class="content w-100" [class.edit-mode]="isEdit">
  <div class="event-card" [class.withdraw-answer]="!hasConfirmed()">
    @if (isDesktop || isEdit) {
      <div class="event-card-header">
        <div>
          @if (withTickets || withSlots) {
            {{ "APP.EVENT_AFTER_ATTEND.GENERIC.THANKS_FOR_ORDER" | translate }}
          } @else {
            {{ getHeaderStatus() }}
          }
        </div>
        <div class="close-button-custom">
          <i class="far fa-times icon-regular" (click)="onClose()"></i>
        </div>
      </div>
    }

    @if (!withTickets) {
      <div class="page-content">
        @if (isEdit) {
          @if (renderEditor) {
            <app-rich-text-editor
              class="page-title"
              [valueToChange]="getTitle()"
              (updateValue)="saveEditorContent($event, 'title')"
            />
            <app-rich-text-editor
              class="page-description"
              [valueToChange]="getDescription()"
              (updateValue)="saveEditorContent($event, 'description')"
            />
          }
        } @else {
          <div class="page-title" [innerHTML]="getTitle() | safeHtml"></div>
          <div
            class="page-description"
            [innerHTML]="getDescription() | safeHtml"
          ></div>
        }
      </div>
      <div class="event-info">
        <div
          class="event-info-content"
          [class.withdraw-answer]="!hasConfirmed()"
        >
          <div class="event-image">
            <img
              [src]="encodedMainImage()"
              class="key-visual-img"
              alt="Key Visual"
            />
          </div>
          <div class="event-right-content">
            <div class="event-description">
              <div class="event-name">
                {{ event?.name }}
              </div>
              <div class="date-address">
                {{ event?.getDisplayDate() }}
              </div>
            </div>
            @if (isDesktop) {
              @if (!hasConfirmed()) {
                <!--<app-event-info
                  [event]="event"
                  [showDate]="false"
                  [showDescription]="false"
                  class="event-address"
                />-->
                <div class="rsvp-qr-code-actions-cont">
                  <div class="pass-actions">
                    @if (isEdit) {
                      <div class="editable-section">
                        <div
                          class="editable-cta"
                          text-editable
                          [ngModel]="getCtaText()"
                          (ngModelChange)="saveEditorContent($event, 'ctaText')"
                        >
                          {{ getCtaText() }}
                        </div>
                      </div>
                    } @else {
                      <button
                        class="btn btn-primary pop-color"
                        (click)="toTheEvent()"
                      >
                        {{ getCtaText() }}
                      </button>
                    }
                  </div>
                </div>
              } @else {
                <div class="rsvp-qr-code-actions-cont">
                  <div class="pass-actions">
                    @if (isEdit) {
                      <div class="editable-section">
                        <div
                          class="editable-cta"
                          text-editable
                          [ngModel]="getCtaText()"
                          (ngModelChange)="saveEditorContent($event, 'ctaText')"
                        >
                          {{ getCtaText() }}
                        </div>
                      </div>
                    } @else {
                      <button
                        class="btn btn-primary pop-color"
                        (click)="seeRsvpQRCode()"
                      >
                        {{ getCtaText() }}
                      </button>
                    }
                  </div>

                  <div class="add-to-wallet-actions">
                    <div class="google-wallet" (click)="addToWallet()">
                      <img src="assets/add_to_google_wallet.svg" />
                    </div>
                    <div class="apple-wallet" (click)="addToWallet()">
                      <img src="assets/add-to-apple-wallet.svg" />
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    } @else {
      @if (ticketOrder) {
        <div class='page-content'>
          <div
            class="page-title"
            [innerHTML]="
                getTitle() | safeHtml
              "
          ></div>
          <div
            class="page-description"
            [innerHTML]="
                getDescription()
                  | safeHtml
              "
          ></div>
          <app-generic-ticket-info-success
            [ticketOrder]="ticketOrder"
            [event]="event"
            (openTickets)="seeTickets($event)"
            (onClose)="onClose()"
          />
        </div>

      }
    }
  </div>
  @if (isDesktop) {
    <div class="share-options">
      <app-share-buttons
        [event]="event"
        customToastSuccessClass="toast-success-white-event-primary"
      ></app-share-buttons>
      <div class="footer-powered-by-cont">
        <span>{{ "APP.POWERED_BY" | translate }}</span>
        <app-logo-custom-fill
          class="logo"
          [fillColor]="'#FFFFFF'"
          [isGenericPage]="true"
          [height]="16"
          [isSmallLogo]="false"
        />
      </div>
    </div>
  }
</div>
